export const Common = {
    "系统提示":"System reminder",
    "提示":"Tips",
    "暂无内容":"No data",
    "暂无数据":"No data ～",
    "暂无动态":"No dynamic",
    "暂无疑问":"No question",
    "确定":"Confirm",
    "取消":"Cancel",
    "编辑":"Edit",
    "删除":"Delete",
    "归档":"Archive",
    "复制":"Copy",
    "转让":"Transfer",
    "退课":"Quit course",
    "置顶":"Topping",
    "取消置顶":"Cancel Topping",
    "启用加课码":"Enable join code",
    "重置加课码":"Reset join code",
    "停用加课码":"Stop join code",
    "排序":"Sort",
    "完成":"Done",
    "添加活动":"Add Activity",
    "重命名":"Rename",
    "恢复":"Restore",
    "加载中":"loading...",
    "图片加载中":"Picture loading...",
    "加载失败":"Load failed",
    "添加":"Add",
    "保存":"Save",
    "删除提示":"Delete Prompt",
    "删除成功":"Deletion succeeded!",
    "暂无":"None",
    "没有更多了":"No more",
    "添加到章节":"Add to chapter",
    '线上':'Online',
    '线下':'Offline',
    '混合':'Blend',
    "学":"study",
    "教":"teach",
    "协":"assist",
    "请输入名称":"Please enter a name",
    "提交":"Submit",
    "搜索":"Search",
    "变更成功":"Change succeeded",
    "讨论":"comments",
    "按时间顺序":"order by time",
    "老师":"Teacher",
    "发布于":"Published on ",
    "回复":"Reply",
    "暂无评论":"No comments",
    "发送":"Send",
    "请输入":"Please input...",
    "发表评论":"Comment...",
     CourseMenu:{
        "目录":"Catalogue",
        "互动课件":"Interactive courseware",
        "作业":"Homework",
        "测试":"Quiz",
        "资料":"Material",
        "腾讯会议":"Tencent meeting",
        "公告":"Notice",
        "话题":"Topic",
        "互动答题":"Interactive answer",
        "互动":"Interactive",
        "答题":"answer",
        "课件":"Courseware",
        "会议":"Meeting",
        "案例学习":"Case study",
    },
    "选择章节":"选择章节",
    "定时器已存在":"定时器已存在！",
    "全部":"All",
    "发布":"Publish",
    "结束发布":"End Publishing",
    "展开全部":"Expand",
    "条回复":"comments",
    "全部回复":"All comments",
    "第":"Page",
    "页":"",
    "个人详情页":"Personal Details",
    "疑问":"Questions",
    "请输入学生姓名学号":"Please enter the student's name or ID",
    "完成时间":"Completion time: ",
    "分":"",
    "完善成功":"完善成功",
    "选课":"Applicants",
    "人":"",
    "加课":"Students",
    "到期":"Deadline",
    "截止":"",
    "开始时间":"Start time:",
    "创建于":"created at",
    "下一步":"Next step",
    "上一步":"Previous step",
    "错误":"Error",
    "来自":"From:",
    "赞":" ",
    "分享":"share",
    "编辑会议直播":"Edit Live Conference",
    "编辑话题讨论":"Edit topic discussion",
    "编辑文章内容":"Edit article content",
    "编辑视频内容":"Edit video content",
    "仅老师可以申请加入教研室":"Only teachers can apply to join the teaching and research department",
    "请求失败点击重新加载":"Request failed, click to reload",
    "点击进行下载":"Click to download",
    "播放观看":"play",
    "总页":"pages",
    "阅读全文":"Read all",
    "点击查看":"Click to see",
    "申请加入虚拟教研室可以继续阅读和名师一起研讨引用优质教学资源":"You can continue to read, discuss with famous teachers and quote high-quality teaching resources, if you join the virtual teaching and research room",
    "当前文件格式不支持预览请下载到本地查看":"The file format does not support preview online, please download it to view",
    "申明内容来自用户上传著作权归原作者所有如涉侵权问题请联系平台官方客服我们将及时处理":"Statement: The content is uploaded by the user, and the copyright belongs to the original author. In case of infringement, please contact the official customer service of the platform, and we will deal with it in a timely manner",
    "申请加入":"Apply to join",
    "参与评论":"Participate in comments!",
    "阅读":"Read",
    "动态":"Dynamic",
    "资源":"Resources",
    "已加入":"Joined",
    "文科类":"Liberal Arts",
    "您已经加入不需要重复加入":"You have joined, do not need to join again",
    "加入虚拟教研室立即使用":"You can use it immediately after joining the virtual teaching and research room ",
    "根据管理者的权限设置您没有权限下载该资源":"According to the administrator's permission settings, you have no permission to download this resource",
    "请选择一个课程":"Please select a course",
    "该链接无法跳转":"This link cannot jump",
    "点赞":"Like",
    "评论":"Comment",
    "已取消点赞":"Like canceled",
    "点赞成功":"Like successfully",
    "查看链接":"View Links",
    "直播回放 ":"Live playback",
    "浏览":"browses",
    "创建人":"Creator:",
    "授课对象":"Prelect object:",
    "试卷":"Test paper",
    "来自样板课程":"From sample courses:",
    "道试题":"questions",
    "收起":"Upfold",
    "文章":"article",
    "人次参与讨论":"person-time discuss",
    "分享卡":"Sharing Card",
    "长按保存图片或发送给朋友":"Long press to save the picture or send it to your friends.",
    "链接复制失败":"Link copy failed",
    "链接复制成功":"Link copied successfully",
    "已经全部加载完了没有更多了":"All have been loaded, there is no more",
    "继续阅读":"Continue reading",
    "剩余":"There are",
    "条动态未读":"dynamic unread",
    "导入":"Import",
    "课件":"Courseware",
    "发布成功":"Publish successfully",
    "导入成功":"Import successfully",
    "添加成功":"Add successfully",
    "保存成功":"Save successfully",
    "外链":"Outer chain",
    "本地上传":"Local upload",
    "导入已有":"Import existing",
    "文件上传失败":"File upload failed",
    "课前":"before class",
    "全部成员":"All members",
    "慕课视频":"Mooc video",
    "录播":"Screen recording",
    "未发布":"Unpublished",
    "未开始":"Not Started",
    "进行中":"Ongoing",
    "已结束":"End",
    "详情":"Details",
    "已选":"Selected",
    "个课程":"courses",
    "立即加入学习":"Join learning Now",
    "选修课程":"Elective courses",
    "可批量选择课程并加入":"You can select courses in batch and join",
    "人已学习":"people have learned",
    "请至少选择一个课程":"Please select at least one course",
    "请先登录":"Please login first",
    "立即登录":"Sign in now",
    "请先进行身份认证":"Please conduct identity authentication first",
    "立即认证":"Immediate authentication",
    "重命名文件":"Rename file",
    "请输入文件名":"Please enter a file name",
    "修改成功":"Modify successfully",
    "关闭":"Close",
    "刷新成功":"Refresh successfully!",
    "反馈类型":"Feedback type",
    "您的邮箱":"Your email",
    "请输入邮箱地址":"Please enter the email address",
    "问题描述":"Problem description",
    "这里输入您反馈的问题":"Enter your feedback question here...",
    "使用帮助":"Using Help",
    "产品建议":"Product suggestions",
    "功能异常":"Abnormal function",
    "请确认邮箱":"Please confirm the email address",
    "请输入反馈问题":"Please enter feedback question",
    "常见问题":"Common problem",
    "搜索您的问题或关键词":"Search your question or keyword",
    "意见反馈":"Feedback",
    "个搜索结果":"search results",
    "无符合条件的搜索结果":"No matching search results",
    "章节目录":"Chapter",
    "暂无简介":"No introduction",
    "课程内容":"Course content",
    "加入老师的课程后可查看详情并学习":"After joining the teacher's course, you can view the details and learn",
    "该课程已关闭":"The course has been closed",
    "关注课堂派公众号发现更多精彩课程":"Pay attention to Ketangpai official account and discover more wonderful courses",
    "立即加入":"Join now",
    "立即学习":"Learn Now",
    "华文慕课视频":"Chinese Moocs Video",
    "华文慕课外链":"Chinese Moocs outer chain",
    "进入直播":"Enter live",
    "直播未开启":"Live is not enabled",
    "发送弹幕评论":"Send Bullet/Comments...",
    "直播技术由课堂派提供发送弹幕需要先登录课堂派是否立即登录":"Live  technology is provided by Ketangpai. You need to log in to Ketangpai first to send the bullet screen. Do you want to log in now?",
    "前往登录":"Go to Login",
    "继续观看":"Continue watching",
    "直播暂停或已结束":"Live paused or ended",
    "至少选择一个":"Select at least one",
    "全屏预览":"Fullscreen preview",
}